import { render, staticRenderFns } from "./GrowerContractsTab.vue?vue&type=template&id=ef3113f0&scoped=true&"
import script from "./GrowerContractsTab.vue?vue&type=script&lang=js&"
export * from "./GrowerContractsTab.vue?vue&type=script&lang=js&"
import style0 from "./GrowerContractsTab.vue?vue&type=style&index=0&id=ef3113f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3113f0",
  null
  
)

export default component.exports